import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
import '@tokens/typography.stylex';
import { typography } from '@tokens/typography.stylex';
import '@tokens/spacing.stylex';
import { spacing } from '@tokens/spacing.stylex';
import '@tokens/motion.stylex';
import { motion } from '@tokens/motion.stylex';
import '@tokens/radius.stylex';
import { radius } from '@tokens/radius.stylex';

// The one page-level tab look (previously copy-pasted per feature with
// drifting active colors — unified here).
export const styles = {
  bar: {
    k1xSpc: "x78zum5",
    kOIVth: "x1fwedmp",
    kt9PQ7: "xso031l",
    kfdmCh: "x1q0q8m5",
    kL6WhQ: "xra1o3",
    k1K539: "x1cg34oi",
    kXHlph: "xw2csxc",
    kORKVm: "x10wlt62",
    kmuXW: "x2lah0s",
    $$css: true
  },
  tab: {
    k8WAf4: "xw2h9tp",
    k1K539: "x1jyxor1 xz990gb",
    ksu8eU: "xng3xce",
    kt9PQ7: "xlxy82",
    kfdmCh: "x1q0q8m5",
    kL6WhQ: "x16stqrj",
    kWkggS: "xjbqb8w",
    kMv6JI: "xdv2sak",
    k63SB2: "xomqrzn",
    kGuDYH: "x2pyw9z",
    kMwMTN: "xdxw5r1",
    kkrTdU: "x1ypdohk",
    khDVqt: "xuxw1ft",
    kmkexE: "x1k3q35m",
    kI3sdo: "x1a2a7pz xq8uqhm",
    kInvED: "x2ssjo2",
    kDPRdz: "x1tqbdv0",
    kaIpWk: "x2u8bby xk2wg9r",
    kg3NbH: "x1g3f1de xhcbftz",
    keoZOQ: "xdj266r xcu3or4",
    $$css: true
  },
  tabActive: {
    kMwMTN: "x1459q0w",
    kL6WhQ: "x4itno9 xcqg3as",
    kWkggS: "xjbqb8w x1ptx8i0",
    $$css: true
  }
};